module.exports = __webpack_public_path__ + "static/4i-d191f22af3bb50902b99ac577f81a322.woff";